import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Bill from './seat/Bill';
import HowPayDialog from './seat/HowPayDialog';
import { fetchDefault, getNowTimeStamp } from './Utils.js';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const timeList = [
    {
        value: 3000,
        label: '50시간 (2,000원 추가할인)',
    },
    {
        value: 6000,
        label: '100시간 (6,000원 추가할인)',
    },
    {
        value: 12000,
        label: '200시간 (12,000원 추가할인)',
    },
    {
        value: 18000,
        label: '300시간 (18,000원 추가할인)',
    },
    {
        value: 24000,
        label: '400시간 (24,000원 추가할인)',
    },
    {
        value: 30000,
        label: '500시간 (30,000원 추가할인)',
    },
    {
        value: 36000,
        label: '600시간 (36,000원 추가할인)',
    },
    {
        value: 42000,
        label: '700시간 (42,000원 추가할인)',
    },
    {
        value: 48000,
        label: '800시간 (48,000원 추가할인)',
    },
    {
        value: 54000,
        label: '900시간 (54,000원 추가할인)',
    },
    {
        value: 60000,
        label: '1000시간 (60,000원 추가할인)',
    }
];

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    currentTime: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 180,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 300,
    },
    DateTextField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
    menu: {
        width: 180,
    },
}));

export default function Prepaid() {
    const classes = useStyles();

    const [time, setTime] = React.useState(6000);
    
    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [doubleDiscount, setDoubleDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();

    const [currentTime, setCurrentTime] = React.useState();


    const [isSelected, setIsSelected] = React.useState(false);
    const onTimeChange = event => {

        if (!isSelected) {
            setTime(event.target.value);
            setBill(event.target.value);

            setTimeout(function () { setIsSelected(false); }, 1000);
        }
        setIsSelected(true);

    };



    useEffect(() => {

        fetchDefault('/Payment/GetCurrentPrepaid',
            (data) => {
                setCurrentTime(data.time);
            }
        );

        //계산
        setBill(time);

        return () => {
        }
    }, []);

    const setBill = (time) => {
        fetchDefault('/Payment/GetPrepaidBill?time=' + time,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setDoubleDiscount(data.doubleDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>시간정액권</h2>
                </Grid>
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="body1">
                                정액권 구입 후 개인석 이용 시 이용 시간만큼 구입하신 시간에서 차감됩니다. (퇴실 시 남은 시간 다시 충전됩니다. 유효기간 없이 모두 소진할 때까지 이용 가능)
                            </Typography>
                            {currentTime > 0 ? (
                                    <TextField
                                        id="currentTime"
                                        label="현재 정액권 남은 시간"
                                        readonly
                                        className={classes.currentTime}
                                        variant="outlined"
                                        value={Math.floor(currentTime / 60) + '시간' + currentTime % 60 + '분'}
                                    />
                            ) : (<div></div>)}
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 정액권을 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Select"
                        className={classes.textField}
                        value={time}
                        onChange={onTimeChange}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccessTimeIcon />
                                </InputAdornment>
                            ),
                        }}
                    >
                        {timeList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} doubleDiscount={doubleDiscount} usePoint={usePoint} myPoint={myPoint} totalPrice={totalPrice} />
                </Grid>
                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Payment/PayPrepaid?time=' + time}/>
                </Grid>
            </Grid>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/Prepaid.js